import { faChrome } from '@fortawesome/free-brands-svg-icons/faChrome';
import { faCriticalRole } from '@fortawesome/free-brands-svg-icons/faCriticalRole';
import { faEdge } from '@fortawesome/free-brands-svg-icons/faEdge';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faFirefox } from '@fortawesome/free-brands-svg-icons/faFirefox';
import { faFontAwesomeAlt } from '@fortawesome/free-brands-svg-icons/faFontAwesomeAlt';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faJediOrder } from '@fortawesome/free-brands-svg-icons/faJediOrder';
import { faSafari } from '@fortawesome/free-brands-svg-icons/faSafari';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faAtlas } from '@fortawesome/free-solid-svg-icons/faAtlas';
import { faBeer } from '@fortawesome/free-solid-svg-icons/faBeer';
import { faCampground } from '@fortawesome/free-solid-svg-icons/faCampground';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import { faCrown } from '@fortawesome/free-solid-svg-icons/faCrown';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faDiceOne } from '@fortawesome/free-solid-svg-icons/faDiceOne';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons/faEnvelopesBulk';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons/faExternalLink';
import { faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons/faFilterCircleXmark';
import { faHandMiddleFinger } from '@fortawesome/free-solid-svg-icons/faHandMiddleFinger';
import { faHatCowboy } from '@fortawesome/free-solid-svg-icons/faHatCowboy';
import { faHatWizard } from '@fortawesome/free-solid-svg-icons/faHatWizard';
import { faMobile } from '@fortawesome/free-solid-svg-icons/faMobile';
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons/faPeopleGroup';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { faRepeat } from '@fortawesome/free-solid-svg-icons/faRepeat';
import { faRulerCombined } from '@fortawesome/free-solid-svg-icons/faRulerCombined';
import { faRulerHorizontal } from '@fortawesome/free-solid-svg-icons/faRulerHorizontal';
import { faScissors } from '@fortawesome/free-solid-svg-icons/faScissors';
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons/faScrewdriverWrench';
import { faShapes } from '@fortawesome/free-solid-svg-icons/faShapes';
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons/faShieldHalved';
import { faSkull } from '@fortawesome/free-solid-svg-icons/faSkull';
import { faToilet } from '@fortawesome/free-solid-svg-icons/faToilet';
import { faVestPatches } from '@fortawesome/free-solid-svg-icons/faVestPatches';
import {
  caretDownCircle,
  closeCircle,
  closeOutline,
  funnel,
  image,
  images,
  informationCircleOutline,
  list,
  logoAngular,
  logoFacebook,
  logoInstagram,
  logoIonic,
  mail,
  warning,
} from 'ionicons/icons';

export const ionicIcons = {
  closeOutline,
  list,
  images,
  informationCircleOutline,
  mail,
  logoFacebook,
  logoInstagram,
  logoAngular,
  logoIonic,
  funnel,
  caretDownCircle,
  warning,
  image,
  closeCircle,
};

export const fontAwesomeIcons = [
  faCommentDots,
  faExternalLink,
  faFontAwesomeAlt,
  faChrome,
  faSafari,
  faFirefox,
  faEdge,
  faMobile,
  faDesktop,
  faFacebookMessenger,
  faInstagram,
  faWhatsapp,
  faEnvelope,
  faQuestion,
  faHatWizard,
  faAtlas,
  faJediOrder,
  faPeopleGroup,
  faCampground,
  faBeer,
  faCriticalRole,
  faHandMiddleFinger,
  faToilet,
  faRepeat,
  faDiceOne,
  faCrown,
  faSkull,
  faRulerCombined,
  faHatCowboy,
  faVestPatches,
  faScissors,
  faRulerHorizontal,
  faScrewdriverWrench,
  faShapes,
  faShieldHalved,
  faFilterCircleXmark,
  faEnvelopesBulk,
];
